import api from './api';

export const getProducts = async (params) => {
  const response = await api.get('/auth/product', { params });
  return response.data;
};

export const getProduct = async (id) => {
  const response = await api.get(`/auth/product/${id}`);
  return response.data;
};

export const createProduct = async (data) => {
  const response = await api.post('/auth/product', data);
  return response.data;
};

export const updateProduct = async (data) => {
  const response = await api.put('/auth/product', data);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await api.delete(`/auth/product/${id}`);
  return response.data;
};
